/**
 * Custom "Add To Cart Row" — its own quantity stepper + Add to Cart
 * button, working via the Ajax Cart API rather than Dawn's product form,
 * so it doesn't depend on Dawn's own markup/class names. Reads the
 * currently selected variant from the page's hidden `input[name="id"]`
 * at click time, same as the custom Buy Now button, so it always adds
 * whatever variant is currently selected (native picker or the Select
 * Options cards).
 */
(function () {
  'use strict';

  var rows = document.querySelectorAll('.custom-atc-row');
  if (!rows.length) return;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  rows.forEach(function (row) {
    var minusBtn = row.querySelector('[data-qty-minus]');
    var plusBtn = row.querySelector('[data-qty-plus]');
    var qtyInput = row.querySelector('[data-qty-input]');
    var addBtn = row.querySelector('[data-add-to-cart]');
    if (!minusBtn || !plusBtn || !qtyInput || !addBtn) return;

    minusBtn.addEventListener('click', function () {
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
    });

    plusBtn.addEventListener('click', function () {
      qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
    });

    qtyInput.addEventListener('change', function () {
      var val = parseInt(qtyInput.value, 10);
      if (!val || val < 1) qtyInput.value = 1;
    });

    addBtn.addEventListener('click', function () {
      var idInput = document.querySelector('input[name="id"]');
      var variantId = idInput ? idInput.value : null;
      if (!variantId) {
        window.alert('Please select an option first.');
        return;
      }

      var quantity = parseInt(qtyInput.value, 10) || 1;
      var originalText = addBtn.textContent;
      addBtn.disabled = true;
      addBtn.textContent = 'Adding...';

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity }),
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw new Error(data.description || 'Could not add to cart');
            return data;
          });
        })
        .then(function () {
          addBtn.textContent = 'Added ✓';
          refreshCartBubble();
          window.setTimeout(function () {
            addBtn.disabled = false;
            addBtn.textContent = originalText;
          }, 1200);
        })
        .catch(function (err) {
          console.error('Add to cart failed:', err);
          addBtn.disabled = false;
          addBtn.textContent = originalText;
          window.alert('Sorry, something went wrong adding this to your cart.');
        });
    });
  });

  // Best-effort refresh of Dawn's own cart icon bubble (item count) so
  // the header updates without a full page reload. Silently does
  // nothing if Dawn's cart-icon-bubble section isn't present.
  function refreshCartBubble() {
    fetch(root + '?sections=cart-icon-bubble')
      .then(function (res) {
        return res.json();
      })
      .then(function (sections) {
        var html = sections['cart-icon-bubble'];
        var bubble = document.getElementById('cart-icon-bubble');
        if (!html || !bubble) return;
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var newBubble = temp.querySelector('#cart-icon-bubble');
        if (newBubble) bubble.replaceWith(newBubble);
      })
      .catch(function () {});
  }
})();